import React, {RefObject, useCallback, useContext, useEffect, useRef, useState} from 'react';
import {RouteComponentProps, useHistory} from 'react-router-dom';
import {
    IonAlert,
    IonButtons,
    IonCol,
    IonGrid,
    IonHeader,
    IonLoading,
    IonPage,
    IonRow,
    IonText,
    IonToast,
} from '@ionic/react';
import {StyledIonContent, StyledIonTitle, StyledIonToolbar} from '../../components/content/content.style';
import {
    StyledCircleButton,
    StyledHeaderButton,
    StyledHeaderButtonImage,
    StyledSocialButton
} from '../../components/button/button.style';
import {ArrowLeftImage, CheckImage} from "../../utils/styles/icons";
import {ScanButton, StyledContent, StyledReportFormContainer} from './reportPage.style';
import StaticPane from '../../components/pane/static-pane.component';
import {useTranslation} from 'react-i18next';
import {StyledInput} from '../../components/form/input/input.style';
import ReportRowForm, {DataSelectable} from "./components/report/reportRowForm.component";
import {
    checkSpecification,
    findOrderById, findOrderByNumber,
    getCustomName, getNewestImportantInfo,
    getNewestSpecification, getOrderFindErrorReadable,
    getPriceRates,
    isEmptyReport, isReportId,
    minReportDate,
    transformApiFormatToReport,
    validateAvgTimePerComponent,
    validateLogisticContainer,
    validateQuarantinePeriod,
    validateReport,
    validateTimeOverlap
} from "../../services/report.service";
import {AddImage} from "../../utils/styles/icons";
import {Links} from "../links";
import {ReportsContext} from "../mainPage/tabs/reports/panes/reportsPane.component";
import PageLeavingGuard from "../../components/page-leaving/pageLeavingGuard.component";
import {useForm} from "react-hook-form";
import {ReportStatus} from "../../enums/reportStatus";
import {Preferences} from "@capacitor/preferences";
import {Profile} from "../../models/profile";
import SaveConfirmationModal from "./modals/saveConfirmationModal.component";
import {
    getCurrentNetworkStatus, getOfflineDataStatus,
    getReportsData,
    offlineStorageSet,
} from "../../services/offlineSync.service";
import DateInput from "../../components/form/input/date.component";
import {ReportSetting} from "../../enums/report";
import {
    checkSpecification as checkSpecificationFactory,
    findOrderById as findOrderByIdFactory,
    findContainerById as findContainerByIdFactory,
    findContainerByNumber as findContainerByNumberFactory,
    saveReport as saveReportFactory,
    getReports as getReportsFactory,
    getReport as getReportFactory, internalCosts
} from "../../services/reportFactory.service";
import {checkWorkerAvailability} from "../../services/reportOffline.service";
import {v4 as uuidv4, validate as validateUuid} from 'uuid';
import useNavigation from "../../services/navigation.service";
import {TimepickerMinutesIterationsType} from "../../enums/timepickerMinutesIterationsType";
import {PricingType} from "../../enums/pricing";
import {setAddOrderConfiguration} from "../../services/qrCodePage.service";
import TrashRedImage from "../../assets/images/trash-can-red.svg";
import {ProfileType} from "../../enums/profileType";
import {StyledTextarea} from "@components/form/input/textarea.style";
import QrImage from "@assets/images/barcode-qr-1.svg";
import {BarcodeScanner} from "@capacitor-community/barcode-scanner";
import QrScannerModal from "@app/reportPage/modals/qrScannerModal.component";
import {getActiveContract} from "@services/reportFactory.service";
import {Contract as ContractModel} from "@models/contract";
import {getWorkerId} from "@utils/tools/worker";
import {checkWorkersSickLeavesByDate} from "@services/sickLeave.service";
import {useEvent} from "../../hooks/useEvent";
import {EventType} from "../../enums/eventType";
import {Location} from "@modals/location/location.component";
import {getLatestLocation, leave} from "@services/geolocation.service";
import {Network} from "@capacitor/network";
import SaveConfirmationHoursAlertModal from "@app/reportPage/modals/saveConfirmationHoursAlertModal.component";
import {Geolocation} from "@capacitor/geolocation";
import ListModal from "@app/reportPage/modals/listModal.component";
import ArrowDownImage from "@assets/images/down-arrow.svg";
import {StyledBanner} from "@app/mainPage/tabs/profile/profileTab.style";

const MomentRange = require('moment-range');
const Moment = require('moment-timezone')
const moment = MomentRange.extendMoment(Moment);
moment.tz.setDefault('Europe/Warsaw');

interface ReportPageManager {
    setFormSubmitted: Function;
    getFormSubmitted: Function;
}

const contextReportPage: ReportPageManager = {
    setFormSubmitted: () => {

    },
    getFormSubmitted: () => {

    }
};

export const ReportPageContext = React.createContext<ReportPageManager>(contextReportPage);

export type DefectGroup = {
    id?: string;
    defects: Defect[];
    quantity?: number;
    repaired?: number;
    notRepaired?: number;
}

export type Defect = {
    id?: string;
    name: string;
    other?: string;
    defect?: DataSelectable;
}

export type Component = {
    id?: string;
    name: string | undefined;
    number?: string | undefined;
}

export type LogisticContainer = {
    id?: string;
    main_number?: string;
    additional_number?: string;
    quantity?: number;
    checked_parts?: number;
    status?: string;
    component_number: Component;
}

export type ReportRowComments = {
    comment: string;
    partNumber: string;
    additionalInfoA: string;
    additionalInfoB: string;
}

export type ReportRowFile = {
    extension?: string;
    hash?: string;
    mime_type?: string;
    original_name: string;
    path?: string;
    size?: number;
    download_url?: string;
    offline_base64?: string;
}

export type ReportRowWorker = {
    id?: number | null;
    personId: string;
    number?: string;
    avatarUrl?: string | null;
    name: string;
    from?: string;
    to?: string;
    originalFrom?: string;
    originalTo?: string;
    hoursHumanized?: string;
    pricingRate?: DataSelectable;
    rate?: DataSelectable;
    workerOvertime?: boolean;
    clientOvertime?: boolean;
    overrideRate?: boolean;
    workerBonus?: boolean;
    workerReportRateValue?: string;
    withRateZero?: boolean,
    basketProblem?: boolean,
    virtualWorker?: boolean,
    hasActiveSickLeave?: boolean,
}

export type ReportRowMeasurement = {
    measuring_equipment_item_category?: DataSelectable;
    measuring_equipment_order_item?: DataSelectable | null;
    multiplier?: number;
    missing?: boolean;
    hide?: boolean;
    description?: string;
}

export type ReportRow = {
    id?: number | null;
    component: Component;
    quantity?: number | string;
    defectGroups: DefectGroup[];
    comments: ReportRowComments;
    components?: ReportRowComponent[];
    files: ReportRowFile[];
    workers: ReportRowWorker[];
    measurements?: ReportRowMeasurement[];
    skipMeasurements?: boolean;
    deliveryDate?: string,
    key?: string,
}

export type ReportRowComponent = {
    quantity?: number | string;
    componentNumberText: string;
    serialNumber: string;
    levNumber: string;
    deliveryNote: string;
    comment: string;
    batchNumber: string;
    materialNumber: string;
    measureResult1: string;
    measureResult2: string;
    measureResult3: string;
    customField1: string;
    customField2: string;
    customField3: string;
    customField4: string;
    defectGroups: DefectGroup[];
    files: ReportRowFile[];
    new?: boolean,
    id?: number,
    index?: number,
    key?: string,
    createdAt?: string,
}

export type Order = {
    id: string;
    sub_type: string;
    pricing_type: PricingType,
    formatted_number: string;
    factory_number: string;
    logistic_container: boolean;
    complaint_number?: string;
    working_day_end?: string;
    max_components?: number;
    is_component_numbers?: boolean;
    hide_other_persons?: boolean;
    hours_for_select_prev_day?: number;
    days_back_coordinator?: number,
    days_back_team_leader?: number,
    enable_nested_reporting: boolean;
    enable_single_components: boolean;
    enable_multiple_order_reports: boolean;
    is_extended_reporting: boolean;
    nested_reporting_settings: ReportSetting[],
    single_components_settings: ReportSetting[],
    nested_reporting_components: string[];
    specification: {
        id: number;
        newest: boolean;
        hasMeasurements: boolean;
    },
    days_for_quarantine?: number,
    is_client_order?: boolean,
    is_enable_single_label_element_scan: boolean;
    scanning_settings: {
        prefix: boolean;
        manual: boolean;
        qr: boolean;
        logisticContainerShowAlerts: boolean;
        logisticContainerUsePrefix: boolean;
        logisticContainerPrefix: string | null;
    },
    use_time_iterations?: boolean;
    reporting_iteration_type?: TimepickerMinutesIterationsType;
    ep2_scanner_timeout?: string;
    allow_add_report_forward?: boolean;
    place_of_service: DataSelectable,
    is_enabled_data_accuracy_statement: boolean;
    is_hide_overtime: boolean;
    //extended_reporting_settings: any;
    basket_bonus: boolean;
};

export type Report = {
    specificationId: string;
    orderId?: string;
    reportId?: string;
    orderNumber?: string;
    orderFactoryNumber?: string;
    serviceDate: string;
    someBasketWorker?: boolean;
    logisticContainerAdditionalNumber?: string;
    hoursAlertComment?: string;
    logisticContainer?: LogisticContainer;
    logisticContainerNumber?: string;
    closeLogisticContainer?: boolean;
    rows: ReportRow[];
    status?: string;
    offlineUuid?: string;
    onlineBackup?: boolean;
    order?: Order;
    createdByWorkerId?: string;
    additionalOrders: Order[];
    multipleOrders?: boolean;
    createdAt?: string;
    internalCostType?: DataSelectable,
};

type SaveActionParams = {
    draft: boolean;
    stay: boolean;
    skipLimits?: boolean;
    skipPerformance?: boolean;
    skipWorkerHoursLimit?: boolean;
    closeContainer?: boolean;
    skipValidation?: boolean;
}

type SaveAction = {
    func: (...args: any[]) => Promise<void>;
    params: SaveActionParams;
};

interface RouterProps {
    orderId: string;
    specificationId: string;
    reportId?: string;
    reportPreview?: string;
    containerId?: string;
    internalCostReport?: string;
}

interface ReportProps extends RouteComponentProps<RouterProps> {
}

const ReportPage: React.FC<ReportProps> = ({match}) => {
    const reportsContext = useContext(ReportsContext);
    const history = useHistory();
    const {t} = useTranslation();
    const {dispatch, listen, remove} = useEvent();

    const {params: {orderId, specificationId, reportId, reportPreview, containerId, internalCostReport}} = match;

    let reportPreviewBoolean = (reportPreview === '1');
    let isInternalCostReport = (internalCostReport === '1');
    let offline = reportPreview?.includes('offline');

    const [formSubmitted, setFormSubmitted] = useState<any>(false);
    const [saveDisabled, setSaveDisabled] = useState<any>(false);
    const [reportIdState, setReportIdState] = useState<any>(reportId);
    const [showToast, setShowToast] = useState(false);
    const [formSaved, setFormSaved] = useState(false);
    const [outdatedSpecification, updateOutdatedSpecification] = useState(false);
    const [toast, setToast] = useState<any>('');
    const [alertMessage, setAlertMessage] = useState<string | null>(null);

    const contextReportPage = useContext(ReportPageContext);
    contextReportPage.setFormSubmitted = setFormSubmitted;
    contextReportPage.getFormSubmitted = () => {
        return formSubmitted;
    };

    const [report, setReport] = useState<Report | null>();
    const [order, setOrder] = useState<Order | null>();
    const [logisticContainer, setLogisticContainer] = useState<LogisticContainer | null>();
    const [maxInContainer, setMaxInContainer] = useState(false);
    const [orderInternalCosts, updateOrderInternalCosts] = useState<DataSelectable[]>();
    const [showInternalCostsModal, updateShowInternalCostsModal] = useState<boolean>(false);

    const [preSaveAction, setPreSaveAction] = useState<SaveAction | null>(null);
    const [postSaveAction, setPostSaveAction] = useState<SaveAction | null>(null);

    const [showSaveAlert, setShowSaveAlert] = useState(false);
    const [showSaveConfirmationModal, setShowSaveConfirmationModal] = useState(false);
    const [showSaveConfirmationHoursAlertModal, setShowSaveConfirmationHoursAlertModal] = useState(false);
    const [autoSaveActionRowRef, setAutoSaveRowRef] = useState<RefObject<HTMLDivElement>|null>(null);
    const [autoSaveActionRowKey, setAutoSaveRowKey] = useState<number|null>(null);

    const [closeContainer, setCloseContainer] = useState(false);
    const [actionsParams, setActionsParams] = useState<SaveActionParams | null>();
    const [showLoading, updateShowLoading] = useState(false);

    const [showPreSaveValidationAlert, setShowPreSaveValidationAlert] = useState<boolean>(false);
    const [showPostValidationAlert, setShowPostValidationAlert] = useState<boolean>(false);
    const [validationAlertTitle, setValidationAlertTitle] = useState<string>('');
    const [validationAlertMessage, setValidationAlertMessage] = useState<string | null>(null);
    const [validationStep, setValidationStep] = useState<number>(1);
    const [selectedProfile, updateSelectedProfile] = useState<Profile | undefined>();
    const [workerActiveContract, setWorkerActiveContract] = useState<ContractModel | null>();

    const [showPermissionAlert, setShowPermissionAlert] = useState<boolean>(false);
    const [scanField, setScanField] = useState<string>('');
    const [importantInfo, setImportantInfo] = useState<string>('');
    const [showScanModal, setShowScanModal] = useState<boolean>(false);
    const [networkStatus, setNetworkStatus] = useState(true);
    const [latestLocation, setLatestLocation] = useState<Location>();
    const [showLeaveLocationAlert, setShowLeaveLocationAlert] = useState(false);
    const [omitPageLeavingGuard, setOmitPageLeavingGuard] = useState<boolean>(false);

    const editionStartAt = useRef<string>(moment().format('YYYY-MM-DD H:m:s'));

    const getProfileData = async () => {
        let profileId = await Preferences.get({'key': 'profile_id'});
        let profileType = await Preferences.get({'key': 'profile_type'});
        let profileCompanyName = await Preferences.get({'key': 'profile_company_name'});

        if (profileId.value !== null && profileType.value !== null && profileCompanyName.value !== null) {
            updateSelectedProfile({
                id: parseInt(profileId.value),
                type: profileType.value,
                company: {
                    name: profileCompanyName.value
                }
            })
        }
    };

    useEffect(() => {
        const getCurrentNetworkStatus = async () => {
            await Network.getStatus()
                .then(result => {
                    setNetworkStatus(result.connected)
                });
        };

        listen(EventType['REPORT.NETWORK_STATUS_CHANGE'], () => {
            getCurrentNetworkStatus();
        });
    }, []);

    useEffect(() => {
        if (!reportPreviewBoolean) {
            setShowSaveConfirmationModal(true);
        } else {
            setOmitPageLeavingGuard(false);
        }
    }, []);

    const handleBack = () => {
        history.goBack();
    };

    const handleSave = async () => {
        setFormSubmitted(true);

        if (report && order) {
            let manualDefect = false;
            if (selectedProfile) {
                for (let row of report.rows) {
                    for (let defectGroup of row.defectGroups) {
                        for (let defect of defectGroup.defects) {
                            if (defect.other && !defect.defect) {
                                manualDefect = true;
                            }
                        }
                    }
                }
            }

            if (!manualDefect) {
                if (isEmptyReport(report, specificationId == '0', order.enable_single_components)) {
                    setFormSubmitted(false);
                    setShowSaveAlert(true);
                } else {
                    let overlap = validateTimeOverlap(report);
                    if (overlap.length > 0) {
                        setToast(t("reportPage.validation.time_overlap") + ': ' + overlap.join(', '));
                        setShowToast(true);
                    } else {
                        let isValid = await validateReport(report, order, selectedProfile, specificationId == '0', false, logisticContainer, isInternalCostReport);
                        if (isValid) {
                            setShowSaveAlert(true);
                        } else {
                            setToast(t("reportPage.validation.commonError"));
                            setShowToast(true);

                            const errorElement = document.querySelector(
                                `.hasErrors`
                            )

                            if (errorElement) {
                                errorElement.scrollIntoView({behavior: 'smooth'})
                            }
                        }
                    }
                }
            } else {
                setToast(t("reportPage.validation.manualDefectPresent"));
                setShowToast(true);
            }
        }
    };

    const [topEdge, updateTopEdge] = useState<number | undefined>(undefined);

    useForm({mode: 'all'});

    useEffect(() => {
        updateHeight();
    });

    const updateHeight = () => {
        if (header.current?.clientHeight == 0) {
            setTimeout(updateHeight);
        } else {
            updateTopEdge(header.current?.clientHeight);
        }
    };

    const header = useRef<HTMLIonHeaderElement>(null);
    const content = useRef<HTMLDivElement>(null);

    const addRow = () => {
        if (report) {
            let components = [];
            if (order?.is_extended_reporting) {
                components.push({
                    comment: '',
                    defectGroups: [],
                    files: [],
                    componentNumberText: '',
                    quantity: order.enable_single_components ? '1' : '',
                    deliveryNote: '',
                    levNumber: '',
                    serialNumber: '',
                    batchNumber: '',
                    materialNumber: '',
                    measureResult1: '',
                    measureResult2: '',
                    measureResult3: '',
                    customField1: '',
                    customField2: '',
                    customField3: '',
                    customField4: '',
                    key: uuidv4(),
                    index: 0,
                    createdAt: moment().format(),
                } as ReportRowComponent);
            }

            setReport({
                ...report,
                rows: [...report.rows, {
                    component: {
                        name: ''
                    },
                    defectGroups: [],
                    files: [],
                    components: components,
                    comments: {
                        comment: '',
                        partNumber: '',
                        additionalInfoA: '',
                        additionalInfoB: ''
                    },
                    workers: []
                }]
            });
        }
    };

    const handleScan = async (value: string) => {
        if (scanField) {
            if (value.includes('S')) {
                value = value.replace('S', '');
                if (report) {
                    value = value.replace('S', '');
                    report.logisticContainerAdditionalNumber = value;

                    setReport({
                        ...report,
                        logisticContainerAdditionalNumber: report.logisticContainerAdditionalNumber
                    })
                }
                stopScan();

                setShowScanModal(false);
                setScanField('');
            }
        }
    };

    const startScan = async (field: string) => {
        setScanField(field);
        setShowScanModal(true);
    };

    const checkPermission = async () => {
        // check or request permission
        const status = await BarcodeScanner.checkPermission({force: true});

        if (status.granted) {
            // the user granted permission
            return true;
        }

        return false;
    };

    const stopScan = () => {
        BarcodeScanner.showBackground();
        BarcodeScanner.stopScan();
    };

    const scanContainerAdditionalNumber = async (field: string) => {
        let hasPermission = await checkPermission();
        if (!hasPermission) {
            setShowPermissionAlert(true);
        }
        startScan(field);
    }

    const handleRowChange = useCallback((row: ReportRow, index: number) => {
        if (!report) return;

        let updatedRow = row;
        if (order && order.is_extended_reporting) {
            let sum = 0;
            row.components?.forEach((c) => {
                if (c.quantity) {
                    sum += parseInt(c.quantity.toString());
                }
            });
            updatedRow = { ...row, quantity: sum };
        }

        let componentsSum = 0;
        let checkerParts = 0;
        if (updatedRow.components) {
            componentsSum = updatedRow.components.length;
        }
        if (logisticContainer?.checked_parts) {
            checkerParts = logisticContainer.checked_parts;
        }

        if (logisticContainer?.quantity != 0 && logisticContainer?.quantity == (componentsSum + checkerParts)) {
            setMaxInContainer(true);
        } else {
            setMaxInContainer(false);
        }

        // Immutable - zamiast splice
        const newRows = report.rows.map((r, i) => i === index ? updatedRow : r);
        setReport({
            ...report,
            rows: newRows
        });
    }, [report, order, logisticContainer])

    const handleRowRemove = useCallback((index: number) => {
        if (!report) return;

        // Immutable - zamiast splice
        const newRows = report.rows.filter((_, i) => i !== index);
        setReport({
            ...report,
            rows: newRows
        });
    }, [report])

    useEffect(() => {
        getProfileData();
        loadReport();
        loadWorkerActiveContract();
        fetchInternalCosts();
    }, []);

    useEffect(() => {
        const interval = setInterval(checkNewestSpecification, 60000);
        return () => clearInterval(interval);
    }, [order]);

    useEffect(() => {
        checkNewestImportantInfo();

        const interval = setInterval(checkNewestImportantInfo, 90000);
        return () => clearInterval(interval);
    }, [order]);

    const updateList = async (draft: boolean) => {
        await getReportsFactory(draft ? ReportStatus.DRAFT : ReportStatus.NOT_VERIFIED, null)
            .then(response => {
                reportsContext.setReports(response);
            });
    }

    const checkNewestSpecification = async () => {
        if (specificationId != '0' && order && !reportPreviewBoolean) {
            await getNewestSpecification(order.id)
                .then(response => {
                    if (response.data.id != specificationId) {
                        updateOutdatedSpecification(true);
                    }
                });
        }
    }

    const checkNewestImportantInfo = async () => {
        const networkStatus = await getCurrentNetworkStatus();

        if (!networkStatus) {
            return;
        }

        const workerId = await getWorkerId();

        if (workerId && workerId !== 'undefined' && order && !reportPreviewBoolean) {
            const response = await getNewestImportantInfo(order.id);
            const newInfo = response.data.info;

            setImportantInfo(prev => {
                if (prev !== newInfo) {
                    setToast(newInfo);
                    setAlertMessage(newInfo);
                    return newInfo;
                }
                return prev;
            });
        }
    }

    const fetchInternalCosts = async () => {
        if (orderInternalCosts === undefined && isInternalCostReport) {
            await internalCosts(orderId).then(response => {
                updateOrderInternalCosts(response)
            })
        }
    }

    const workerSaveButtons = () => {
        const baseButtons = [
            {
                text: t('reportPage.saveAlert.saveDraft'),
                cssClass: outdatedSpecification ? 'alertButtonDisabled' : '',
                handler: async () => {
                    setPreSaveAction({ func: handleSaveReport, params: { draft: true, stay: false } });
                }
            },
            {
                text: t('reportPage.saveAlert.saveDraftAndStay'),
                cssClass: outdatedSpecification ? 'alertButtonDisabled' : '',
                handler: async () => {
                    setPreSaveAction({ func: handleSaveReport, params: { draft: true, stay: true } });
                }
            },
            {
                text: t('reportPage.saveAlert.save'),
                cssClass: report && isEmptyReport(report, specificationId == '0', order?.enable_single_components) ? 'alertButtonDisabled' : '',
                handler: async () => {
                    setCloseContainer(false);
                    setPreSaveAction({
                        func: handleSaveReport,
                        params: { draft: false, stay: false, skipLimits: false, skipPerformance: false, skipWorkerHoursLimit: false, closeContainer }
                    });
                }
            }
        ];

        if (logisticContainer || report?.logisticContainer) {
            return [
                {
                    text: t('reportPage.saveAlert.saveAndCloseContainer'),
                    cssClass: report && isEmptyReport(report, specificationId == '0', order?.enable_single_components) ? 'alertButtonDisabled' : '',
                    handler: async () => {
                        setCloseContainer(true);
                        setPreSaveAction({
                            func: handleSaveReport,
                            params: { draft: false, stay: false, skipLimits: false, skipPerformance: false, skipWorkerHoursLimit: false, closeContainer: true }
                        });
                    }
                },
                ...baseButtons
            ];
        }

        return baseButtons;
    };

    const profileSaveButtons = () => {
        if (logisticContainer || report?.logisticContainer) {
            return [
                {
                    text: t('reportPage.saveAlert.saveAndCloseContainer'),
                    cssClass: report ? (isEmptyReport(report, specificationId == '0', order?.enable_single_components) || (!networkStatus) ? 'alertButtonDisabled' : '') : '',
                    handler: async () => {
                        setCloseContainer(true);
                        setPreSaveAction({func: handleSaveReport, params: {draft: false, stay: false, skipLimits: false, skipWorkerHoursLimit: false, skipPerformance: false, closeContainer: true}});
                    }
                },
                {
                    text: t('reportPage.saveAlert.save'),
                    cssClass: report ? (isEmptyReport(report, specificationId == '0', order?.enable_single_components) || (!networkStatus) ? 'alertButtonDisabled' : '') : '',
                    handler: async () => {
                        setCloseContainer(false);
                        setPreSaveAction({func: handleSaveReport, params: {draft: false, stay: false}});
                    }
                },
            ];
        } else {
            return [
                {
                    text: t('common.alertCancel'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => setShowSaveAlert(false),
                },
                {
                    text: t('common.alertConfirm'),
                    cssClass: report ? (isEmptyReport(report, specificationId == '0', order?.enable_single_components) || (!networkStatus) ? 'alertButtonDisabled' : '') : '',
                    handler: async () => {
                        setCloseContainer(false);
                        setPreSaveAction({func: handleSaveReport, params: {draft: false, stay: false}});
                    }
                }
            ];
        }
    }

    const loadLogisticContainer = async () => {
        if (logisticContainer === undefined) {
            if (containerId) {
                let tmpLogisticContainer = await findContainerByIdFactory(containerId).then((response) => {
                    let logisticContainer = response as LogisticContainer;
                    setLogisticContainer(logisticContainer);

                    return logisticContainer;
                }).catch(() => {
                    history.replace(Links.main + Links.reports);
                })

                return tmpLogisticContainer;
            }
        }
    }

    const loadOrder = async () => {
        const networkStatus = await getCurrentNetworkStatus();
        if (order === undefined) {
            updateShowLoading(true);

            if (specificationId != '0') {
                let tmpOrder = await checkSpecificationFactory(specificationId, reportIdState, true).then((response) => {
                    let order = response as Order;
                    if (!reportPreviewBoolean && parseInt(specificationId) != order.specification.id) {
                        updateOutdatedSpecification(true);
                    } else {
                        updateOutdatedSpecification(false);
                    }
                    setOrder(order);
                    if (networkStatus) {
                        syncOfflineData(order.place_of_service.id.toString(), order.id);
                    }

                    updateShowLoading(false);
                    return order;
                }).catch((error) => {
                    updateShowLoading(false);
                    history.replace(Links.main + Links.reports);
                })

                return tmpOrder;
            } else {
                let tmpOrder = await findOrderByIdFactory(orderId, true).then((response) => {
                    let order = response as Order;
                    setOrder(order);
                    if (networkStatus) {
                        syncOfflineData(order.place_of_service.id.toString(), order.id);
                    }

                    updateShowLoading(false);
                    return order;
                }).catch((error) => {
                    updateShowLoading(false);
                    history.replace(Links.main + Links.reports);
                })

                return tmpOrder;
            }
        }
    }

    const loadReport = async (forceReload = false, reportId: null | number = null, addNewComponent: boolean = false, rowIndexNewComponent: null | number = null, skipOffline:boolean = false) => {
        if (report === undefined || forceReload) {
            if (containerId) {
                await loadLogisticContainer();
            }
            let o = await loadOrder();
            if ((reportIdState && parseInt(reportIdState) !== 0) || (reportId !== null)) {
                let reportIdToLoad = reportId || reportIdState;
                let reportIdOffline: boolean = !!(reportIdToLoad && validateUuid(reportIdToLoad.toString()));
                if (reportIdToLoad && parseInt(reportIdToLoad) !== 0) {
                    await getReportFactory(reportIdToLoad, skipOffline ? false : offline || reportIdOffline).then((response) => {
                        if (response.status && (response.status == ReportStatus.OFFLINE_DRAFT || response.status == ReportStatus.OFFLINE_READY_TO_SYNC)) {
                            setReport(response);
                            if (response.logisticContainer) {
                                let l = response.logisticContainer;
                                l.checked_parts = l.checked_parts - response.rows[0].checked_parts;
                                setLogisticContainer(l);
                            }
                        } else {
                            setReport(transformApiFormatToReport(response, addNewComponent, rowIndexNewComponent));

                            if (response.logistic_container){
                                let l = response.logistic_container;
                                l.checked_parts = l.checked_parts - response.rows[0].checked_parts;
                                setLogisticContainer(l);
                            }
                        }
                    }).catch((e) => {
                        history.replace(Links.main + Links.reports);
                    })
                }
            } else {
                let components = [];

                if (!isInternalCostReport) {
                    components.push({
                        comment: '',
                        defectGroups: [],
                        files: [],
                        componentNumberText: '',
                        quantity: o && o?.enable_single_components ? '1' : '',
                        deliveryNote: '',
                        levNumber: '',
                        serialNumber: '',
                        batchNumber: '',
                        materialNumber: '',
                        measureResult1: '',
                        measureResult2: '',
                        measureResult3: '',
                        customField1: '',
                        customField2: '',
                        customField3: '',
                        customField4: '',
                        key: uuidv4(),
                        index: 0,
                        createdAt: moment().format(),
                    } as ReportRowComponent);
                }

                const networkStatus = await getCurrentNetworkStatus();

                setReport({
                    offlineUuid: !networkStatus ? uuidv4() : undefined,
                    orderId: order?.id,
                    specificationId: specificationId,
                    orderNumber: order?.formatted_number,
                    orderFactoryNumber: order?.factory_number,
                    logisticContainerAdditionalNumber: '',
                    hoursAlertComment: '',
                    serviceDate: moment().format(),
                    additionalOrders: [],
                    rows: [
                        {
                            component: {
                                name: ''
                            },
                            quantity: undefined,
                            defectGroups: [],
                            files: [],
                            components: components,
                            comments: {
                                comment: '',
                                partNumber: '',
                                additionalInfoA: '',
                                additionalInfoB: ''
                            },
                            workers: [],
                        }
                    ]
                });
            }
        }
    }

    const loadWorkerActiveContract = async () => {
        const workerId = await getWorkerId();

        if (workerId && workerId !== 'undefined') {
            const response = await getActiveContract();
            setWorkerActiveContract(response as ContractModel);
        }
    }

    const clearWorkersPricingRates = async () => {
        if (report?.serviceDate) {
            let rates = await getPriceRates(orderId, reportIdState, moment(report?.serviceDate).format('DD-MM-YYYY'))
                .then(response => {
                    return response.data as DataSelectable[];
                });

            for (let row of report.rows) {
                for (let worker of row.workers) {
                    if (worker.pricingRate && !rates.filter((element) => {
                        return worker.pricingRate?.id === element.id;
                    })) {
                        worker.pricingRate = undefined;
                        setFormSubmitted(true);
                    }
                }
            }
        }
    }

    const validateSickLeave = async (date: string) => {
        if (!report) return true;

        const workers = report.rows.flatMap(row => row.workers).filter(w => w.personId);

        if (workers.length === 0) return true;

        const results = await checkWorkersSickLeavesByDate(workers, date);
        const hasAnyActive = results.some(r => r.hasActiveSickLeave);

        if (hasAnyActive) {
            setToast(t("reportPage.validation.hasActiveSickLeave"));
            setShowToast(true);
            return false;
        }

        return true;
    };

    const validateOfflineWorkerAvailability = async () => {
        const networkStatus = await getCurrentNetworkStatus();
        if (networkStatus) {
            return true;
        }

        if (!report || !order) {
            return true;
        }

        const unavailableWorkers: string[] = [];

        for (const row of report.rows) {
            if (!row.workers || row.workers.length === 0) {
                continue;
            }

            for (const worker of row.workers) {
                if (!worker.from || !worker.to) {
                    continue;
                }

                const isAvailable = await checkWorkerAvailability(
                    parseInt(worker.personId),
                    moment(report.serviceDate).format('YYYY-MM-DD'),
                    moment(worker.from, moment.ISO_8601).format('HH:mm'),
                    moment(worker.to, moment.ISO_8601).format('HH:mm'),
                    parseInt(order.place_of_service.id)
                );

                if (!isAvailable && !unavailableWorkers.includes(worker.name)) {
                    unavailableWorkers.push(worker.name);
                }
            }
        }

        if (unavailableWorkers.length > 0) {
            setToast(t("reportPage.validation.noAvailabilityFoundForWorkers", {workers: unavailableWorkers.join(', '), placeOfService: order.place_of_service.name}));
            setShowToast(true);
            return false;
        }

        return true;
    }

    useEffect(() => {
        if (preSaveAction) {
            preSaveValidate();
        }
    }, [validationStep, preSaveAction]);

    const validationFunctions = [
        validateQuarantinePeriod,
        validateAvgTimePerComponent,
        validateLogisticContainer,
    ];

    const preSaveValidate = async () => {
        updateShowLoading(true);

        if (report?.serviceDate && !selectedProfile?.type) {
            const sickLeaveValidationResult = await validateSickLeave(report.serviceDate)

            if (!sickLeaveValidationResult) {
                updateShowLoading(false);
                return;
            }
        }

        const availabilityValidationResult = await validateOfflineWorkerAvailability();

        if (!availabilityValidationResult) {
            updateShowLoading(false);
            return;
        }

        if (report && order) {
            if (validationStep === 1 && !preSaveAction?.params.draft && !validateQuarantinePeriod(order, report.serviceDate)) {
                handlePreSaveValidationAlertOpen('reportPage.quarantineAlert.title');
                updateShowLoading(false);
                return;
            }

            if (validationStep === 2 && !preSaveAction?.params.draft && !validateAvgTimePerComponent(report)) {
                handlePreSaveValidationAlertOpen('reportPage.avgTimePerComponentAlert.title');
                updateShowLoading(false);
                return;
            }

            if (validationStep === 3 && !preSaveAction?.params.draft && !validateLogisticContainer(maxInContainer, closeContainer)) {
                handlePreSaveValidationAlertOpen('reportPage.logisticContainerAlert.title');
                updateShowLoading(false);
                return;
            }
        }

        if (preSaveAction) {
            if (validationStep < validationFunctions.length) {
                setValidationStep(prevState => prevState + 1);
            } else {
                const action = preSaveAction;
                setPreSaveAction(null);
                updateShowLoading(false);
                setActionsParams(action.params);
                await action.func(action.params);
            }
        }
    }

    const handleAutoSaveReport = async (rowRef: RefObject<HTMLDivElement>, key: number) => {
        if (saveDisabled) {
            return false;
        }
        setSaveDisabled(true);

        setAutoSaveRowRef(rowRef);
        setAutoSaveRowKey(key);

        if (report && order) {
            try {
                const response = await saveReportFactory(order, report, reportIdState, true, true, true, true, offline, logisticContainer?.id, closeContainer, true, editionStartAt.current);
                const id = response.id || response.reportId;

                setAutoSaveRowRef(null);
                setAutoSaveRowKey(null);
                setSaveDisabled(false);

                if (id) {
                    setReportIdState(id);
                    return id;
                }

                return reportIdState;
            } catch (error) {
                setSaveDisabled(false);
                if (error.response.status === 400) {
                    try {
                        let message = error.response.data.errors.children.rows.errors[0];
                        if (!toast && message) {
                            setToast(t("reportPage.validation.report.componentNumbersNotUnique") + ' ' +  message.split('=')[1]);
                        }
                    } catch (e) {
                        setToast(t("reportPage.validation.commonError"));
                    }

                try {
                    let rowsErrors = error.response.data.errors.children.rows.children;
                    for (let rowError in rowsErrors) {
                        let componentsError = rowsErrors[rowError].children.components?.children;
                        let workersError = rowsErrors[rowError].children.workers?.children;
                        let workersGeneralError = rowsErrors[rowError].children.workers?.errors;

                        if (workersGeneralError && workersGeneralError.length > 0) {
                            workersGeneralError.forEach((workerGeneralError: string) => {
                                if (workerGeneralError && workerGeneralError.includes('Availability not found for')) {
                                    const workerNames = workerGeneralError.replace('Availability not found for:', '').trim();

                                    setToast(t("reportPage.validation.noAvailabilityFoundForWorkers", {placeOfService: order.place_of_service.name, workers: workerNames}));
                                }
                            })
                        }

                        for (let workerError in workersError) {
                            let workerErrors = workersError[workerError].children.worker?.errors;
                            if (workerErrors && workerErrors[0].includes('already exists')) {
                                setToast(t("reportPage.validation.workerReportAlreadyExists", {reports: workerErrors[0].split('=')[1]}));
                            }
                        }

                        for (let componentError in componentsError) {
                            let componentNumberTextErrors = componentsError[componentError].children.componentNumberText?.errors;
                            if (componentNumberTextErrors && componentNumberTextErrors[0].includes('already exists')) {
                                const customName = order ? getCustomName(ReportSetting.COMPONENT_NUMBER_CUSTOM_NAME, order) : null;
                                if (customName) {
                                    setToast(t("reportPage.validation.componentNumberAlreadyExitsWithName", { fieldName: customName }));
                                } else {
                                    setToast(t("reportPage.validation.componentNumberAlreadyExits"));
                                }
                            }

                                let levNumberErrors = componentsError[componentError].children.levNumber?.errors;
                                if (levNumberErrors && levNumberErrors[0].includes('already exists')) {
                                    const customName = order ? getCustomName(ReportSetting.LEV_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.levNumberAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.levNumberAlreadyExits"));
                                    }
                                }

                                let materialNumberErrors = componentsError[componentError].children.materialNumber?.errors;
                                if (materialNumberErrors && materialNumberErrors[0].includes('already exists')) {
                                    const customName = order ? getCustomName(ReportSetting.MATERIAL_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.materialNumberAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.materialNumberAlreadyExits"));
                                    }
                                }

                                let serialNumberErrors = componentsError[componentError].children.serialNumber?.errors;
                                if (serialNumberErrors && serialNumberErrors?.some((err: string) => err.includes('already exists'))) {
                                    const customName = order ? getCustomName(ReportSetting.SERIAL_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                      setToast(t("reportPage.validation.serialNumberAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                      setToast(t("reportPage.validation.serialNumberAlreadyExits"));
                                    }
                                }
                                if (serialNumberErrors && serialNumberErrors?.some((err: string) => err.includes('Serial number not valid'))) {
                                    const customName = order ? getCustomName(ReportSetting.SERIAL_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                      setToast(t("reportPage.validation.serialNumberNotValidWithName", { fieldName: customName }));
                                    } else {
                                      setToast(t("reportPage.validation.serialNumberNotValid"));
                                    }
                                }

                                let batchNumberErrors = componentsError[componentError].children.batchNumber?.errors;
                                if (batchNumberErrors && batchNumberErrors[0].includes('already exists')) {
                                    const customName = order ? getCustomName(ReportSetting.BATCH_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.batchNumberAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.batchNumberAlreadyExits"));
                                    }
                                }

                                let deliveryNoteErrors = componentsError[componentError].children.deliveryNote?.errors;
                                if (deliveryNoteErrors && deliveryNoteErrors[0].includes('already exists')) {
                                    const customName = order ? getCustomName(ReportSetting.DELIVERY_NOTE_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.deliveryNoteAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.deliveryNoteAlreadyExits"));
                                    }
                                }

                                let measureResult1Errors = componentsError[componentError].children.measureResult1?.errors;
                                if (measureResult1Errors && measureResult1Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.MEASURE_RESULT_1_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.measureResult1AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.measureResult1AlreadyExits"));
                                    }
                                }

                                let measureResult2Errors = componentsError[componentError].children.measureResult2?.errors;
                                if (measureResult2Errors && measureResult2Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.MEASURE_RESULT_2_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.measureResult2AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.measureResult2AlreadyExits"));
                                    }
                                }

                                let measureResult3Errors = componentsError[componentError].children.measureResult3?.errors;
                                if (measureResult3Errors && measureResult3Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.MEASURE_RESULT_3_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.measureResult3AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.measureResult3AlreadyExits"));
                                    }
                                }
                                
                                let customField1Errors = componentsError[componentError].children.customField1?.errors;
                                if (customField1Errors && customField1Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.CUSTOM_FIELD_1_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.customField1AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.customField1AlreadyExits"));
                                    }
                                }

                                let customField2Errors = componentsError[componentError].children.customField2?.errors;
                                if (customField2Errors && customField2Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.CUSTOM_FIELD_2_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.customField2AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.customField2AlreadyExits"));
                                    }
                                }
                                
                                let customField3Errors = componentsError[componentError].children.customField3?.errors;
                                if (customField3Errors && customField3Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.CUSTOM_FIELD_3_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.customField3AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.customField3AlreadyExits"));
                                    }
                                }
                                
                                let customField4Errors = componentsError[componentError].children.customField4?.errors;
                                if (customField4Errors && customField4Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.CUSTOM_FIELD_4_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.customField4AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.customField4AlreadyExits"));
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        setToast(t("reportPage.validation.commonError"));
                    }

                    try {
                        let message = error.response.data.errors.errors[0];
                        if (message && 'HOURS-ALERT' === message) {
                            setShowSaveConfirmationHoursAlertModal(true);
                            return false;
                        }
                    } catch (e) {
                    }

                } else if (error.response.status === 403) {
                    setToast(t("reportPage.validation.reportLocked"));
                } else {
                    setToast(t("common.serverErrorMsg"));
                }

                setShowToast(true);
                return false;
            }
        }

        return false;
    }

    const handleSaveReport = async ({draft, stay, skipLimits = false, skipPerformance = false, skipWorkerHoursLimit = false, closeContainer = false, skipValidation = false}: SaveActionParams) => {
        const networkStatus = await getCurrentNetworkStatus();
        if (report && order) {
            updateShowLoading(true);

            if (!draft && !networkStatus) {
                let isValid = await validateReport(report, order, selectedProfile, specificationId == '0', true, null, isInternalCostReport);
                if (!isValid) {
                    setToast(t("reportPage.validation.workerEndTimeRequired"));
                    setShowToast(true);
                    handleValidationAlertCancel();
                    updateShowLoading(false);
                    return;
                }
            }

            if (saveDisabled) {
                return;
            }
            setSaveDisabled(true);

            try {
                const response = await saveReportFactory(order, report, reportIdState, draft, skipLimits, skipPerformance, skipWorkerHoursLimit, offline, logisticContainer?.id, closeContainer, skipValidation, editionStartAt.current);
                updateList(draft);
                const id = response.id || response.reportId;
                if (id) {
                    setReportIdState(id);
                }

                let idToReload = id || reportIdState;
                if (stay && idToReload && isReportId(idToReload)) {
                    await loadReport(true, idToReload, false, null, true);
                }

                setAutoSaveRowRef(null);
                setAutoSaveRowKey(null);
                setSaveDisabled(false);

                if (stay && isReportId(response.id)) {
                    await loadReport(true, response.id);
                }

                setFormSaved(true);
                if (!stay) {
                    if (latestLocation && !draft) {
                        setShowLeaveLocationAlert(true);
                    } else {
                        history.replace(Links.main + Links.reports);
                    }
                }
            } catch (error) {
                let isErrorMessage = false;
                setSaveDisabled(false);
                if (error.response.status === 400) {
                    try {
                        let rowsErrors = error.response.data.errors.children.rows.children;
                        for (let rowError in rowsErrors) {
                            let workersGeneralError = rowsErrors[rowError].children.workers?.errors;

                            if (workersGeneralError && workersGeneralError.length > 0) {
                                workersGeneralError.forEach((workerGeneralError: string) => {
                                    if (workerGeneralError && workerGeneralError.includes('Availability not found for')) {
                                        const workerNames = workerGeneralError.replace('Availability not found for:', '').trim();

                                        setToast(t("reportPage.validation.noAvailabilityFoundForWorkers", {placeOfService: order.place_of_service.name, workers: workerNames}));
                                        isErrorMessage = true;
                                    }
                                })
                            }

                            let workersError = rowsErrors[rowError].children.workers?.children;
                            for (let workerError in workersError) {
                                let basketErrors = workersError[workerError].children.worker?.errors;
                                if (basketErrors && (basketErrors[0] === 'app.basket.not_enough' || basketErrors.hasOwnProperty(1) && basketErrors[1] === 'app.basket.not_enough')) {
                                    if (report){
                                        for (let row of report.rows) {
                                            let i = 0;
                                            row.workers.forEach((worker, key) => {
                                                 if (key == Number(workerError) || Number(workerError) == worker.id){
                                                     worker.basketProblem = true;
                                                 }
                                                i = i + 1;
                                            });
                                        }
                                    }

                                    setToast(t("reportPage.validation.basket"));
                                    isErrorMessage = true;
                                }

                                if (basketErrors && (basketErrors[0] === 'app.basket.cant_change_date' || basketErrors.hasOwnProperty(1) && basketErrors[1] === 'app.basket.cant_change_date')) {
                                    if (report){
                                        for (let row of report.rows) {
                                            let i = 0;
                                            row.workers.forEach((worker, key) => {
                                                if (key == Number(workerError) || Number(workerError) == worker.id){
                                                    worker.basketProblem = true;
                                                }
                                                i = i + 1;
                                            });
                                        }
                                    }

                                    setToast(t("reportPage.validation.basket_date"));
                                    isErrorMessage = true;
                                }

                                let endAtErrors = workersError[workerError].children.endAt?.errors;
                                if (endAtErrors && endAtErrors[0] === 'This value is not valid.') {
                                    setToast(t("reportPage.validation.workerHoursPassedShift"));
                                    isErrorMessage = true;
                                }

                                if (endAtErrors && endAtErrors[0] === 'This value should not be blank.') {
                                    setToast(t("reportPage.validation.workerEndTimeRequired"));
                                    isErrorMessage = true;
                                }

                                let workerErrors = workersError[workerError].children.worker?.errors;
                                if (workerErrors && workerErrors[0].includes('already exists')) {
                                    setToast(t("reportPage.validation.workerReportAlreadyExists", {reports: workerErrors[0].split('=')[1]}));
                                    isErrorMessage = true;
                                }

                                if (workerErrors && workerErrors[0] === 'app.order_report.invalid_worker') {
                                    setToast(t("reportPage.validation.workerHasNoContractForThisServiceDate"));
                                    isErrorMessage = true;
                                }

                                if (workerErrors && workerErrors[0] === 'app.order_report.invalid_worker_delegation') {
                                    setToast(t("reportPage.validation.workerHasDelegationProblem"));
                                    isErrorMessage = true;
                                }

                                let rateError = workersError[workerError].children.rate?.errors;
                                if (!toast && rateError) {
                                    setToast(t("reportPage.validation.workerRateNotSelected"));
                                    isErrorMessage = true;
                                }

                                let pricingRateError = workersError[workerError].children.pricingRate?.errors;
                                if (!toast && pricingRateError) {
                                    setToast(t("reportPage.validation.workerPricingRateNotSelected"));
                                    isErrorMessage = true;
                                }
                            }

                            let componentsError = rowsErrors[rowError].children.components?.children;
                            for (let componentError in componentsError) {
                                let componentNumberTextErrors = componentsError[componentError].children.componentNumberText?.errors;
                                if (componentNumberTextErrors && componentNumberTextErrors[0].includes('already exists')) {
                                    const customName = order ? getCustomName(ReportSetting.COMPONENT_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.componentNumberAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.componentNumberAlreadyExits"));
                                    }
                                    isErrorMessage = true;
                                }

                                let levNumberErrors = componentsError[componentError].children.levNumber?.errors;
                                if (levNumberErrors && levNumberErrors[0].includes('already exists')) {
                                    const customName = order ? getCustomName(ReportSetting.LEV_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.levNumberAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.levNumberAlreadyExits"));
                                    }
                                    isErrorMessage = true;
                                }

                                let materialNumberErrors = componentsError[componentError].children.materialNumber?.errors;
                                if (materialNumberErrors && materialNumberErrors[0].includes('already exists')) {
                                    const customName = order ? getCustomName(ReportSetting.MATERIAL_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.materialNumberAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.materialNumberAlreadyExits"));
                                    }
                                    isErrorMessage = true;
                                }

                                let serialNumberErrors = componentsError[componentError].children.serialNumber?.errors;
                                if (serialNumberErrors?.some((err: string) => err.includes('already exists'))) {
                                    const customName = order ? getCustomName(ReportSetting.SERIAL_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.serialNumberAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.serialNumberAlreadyExits"));
                                    }
                                    isErrorMessage = true;
                                }

                                if (serialNumberErrors && serialNumberErrors?.some((err: string) => err.includes('Serial number not valid'))) {
                                    const customName = order ? getCustomName(ReportSetting.SERIAL_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                      setToast(t("reportPage.validation.serialNumberNotValidWithName", { fieldName: customName }));
                                    } else {
                                      setToast(t("reportPage.validation.serialNumberNotValid"));
                                    }
                                }

                                let batchNumberErrors = componentsError[componentError].children.batchNumber?.errors;
                                if (batchNumberErrors && batchNumberErrors[0].includes('already exists')) {
                                    const customName = order ? getCustomName(ReportSetting.BATCH_NUMBER_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.batchNumberAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.batchNumberAlreadyExits"));
                                    }
                                    isErrorMessage = true;
                                }

                                let deliveryNoteErrors = componentsError[componentError].children.deliveryNote?.errors;
                                if (deliveryNoteErrors && deliveryNoteErrors[0].includes('already exists')) {
                                    const customName = order ? getCustomName(ReportSetting.DELIVERY_NOTE_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.deliveryNoteAlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.deliveryNoteAlreadyExits"));
                                    }
                                    isErrorMessage = true;
                                }

                                let measureResult1Errors = componentsError[componentError].children.measureResult1?.errors;
                                if (measureResult1Errors && measureResult1Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.MEASURE_RESULT_1_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.measureResult1AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.measureResult1AlreadyExits"));
                                    }
                                }

                                let measureResult2Errors = componentsError[componentError].children.measureResult2?.errors;
                                if (measureResult2Errors && measureResult2Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.MEASURE_RESULT_2_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.measureResult2AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.measureResult2AlreadyExits"));
                                    }
                                }

                                let measureResult3Errors = componentsError[componentError].children.measureResult3?.errors;
                                if (measureResult3Errors && measureResult3Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.MEASURE_RESULT_3_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.measureResult3AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.measureResult3AlreadyExits"));
                                    }
                                }
                                
                                let customField1Errors = componentsError[componentError].children.customField1?.errors;
                                if (customField1Errors && customField1Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.CUSTOM_FIELD_1_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.customField1AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.customField1AlreadyExits"));
                                    }
                                }
                                
                                let customField2Errors = componentsError[componentError].children.customField2?.errors;
                                if (customField2Errors && customField2Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.CUSTOM_FIELD_2_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.customField2AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.customField2AlreadyExits"));
                                    }
                                }
                                
                                let customField3Errors = componentsError[componentError].children.customField3?.errors;
                                if (customField3Errors && customField3Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.CUSTOM_FIELD_3_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.customField3AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.customField3AlreadyExits"));
                                    }
                                }

                                let customField4Errors = componentsError[componentError].children.customField4?.errors;
                                if (customField4Errors && customField4Errors[0].includes("already exists")) {
                                    const customName = order ? getCustomName(ReportSetting.CUSTOM_FIELD_4_CUSTOM_NAME, order) : null;
                                    if (customName) {
                                        setToast(t("reportPage.validation.customField4AlreadyExitsWithName", { fieldName: customName }));
                                    } else {
                                        setToast(t("reportPage.validation.customField4AlreadyExits"));
                                    }
                                }
                            }

                            if (rowsErrors[rowError].children.deliveryDate.errors) {
                                setToast(t("reportPage.validation.deliveryDateInvalid"));
                                isErrorMessage = true;
                            }
                        }
                    } catch (e) {
                        setToast(t("reportPage.validation.commonError"));
                    }


                    try {
                        let message = error.response.data.errors.errors[0];
                        if (message && 'HOURS-ALERT' == message) {
                            setShowSaveConfirmationHoursAlertModal(true);
                            return;
                        }
                    } catch (e) {
                    }

                    try {
                        let message = error.response.data.errors.children.checkPerformance.errors[0];
                        if (message) {
                            handlePostSaveValidationAlertOpen('reportPage.checkPerformance.title', {func: handleSaveReport, params: {draft: draft, stay: stay, skipLimits: true, skipPerformance: true, skipWorkerHoursLimit: true, closeContainer: closeContainer}});
                            updateShowLoading(false);
                            return;
                        } else {
                            if (!toast && message) {
                                setToast(t("reportPage.validation.checkLimit"));
                                isErrorMessage = true;
                            }
                        }
                    } catch (e) {
                    }

                    try {
                        const errors = error.response?.data?.errors?.children || {};

                        const workerDailyHoursLimitMessage = errors.workerDailyHoursLimit?.errors?.[0];
                        const limitMessage = errors.limit?.errors?.[0];

                        // jeśli obie walidacje nie przeszły ta do limit i ta do workerDailyHoursLimit
                        if (workerDailyHoursLimitMessage && limitMessage &&
                            reportIdState === '0' &&
                            order.is_client_order &&
                            selectedProfile?.type &&
                            (selectedProfile.type === ProfileType.COORDINATOR || selectedProfile.type === ProfileType.TEAM_LEADER)) {
                            handlePostSaveValidationAlertOpen('reportPage.multipleValidation.title', {
                                func: handleSaveReport,
                                params: {
                                    draft,
                                    stay,
                                    skipLimits: true,
                                    skipPerformance: true,
                                    skipWorkerHoursLimit: true,
                                    closeContainer: closeContainer
                                }
                            },
                                workerDailyHoursLimitMessage
                            );
                            updateShowLoading(false);
                            return;
                        }

                        // tylko workerDailyHoursLimit
                        if (workerDailyHoursLimitMessage) {
                            handlePostSaveValidationAlertOpen('reportPage.workerDailyHoursLimit.title', {
                                func: handleSaveReport,
                                params: {
                                    draft,
                                    stay,
                                    skipLimits: false,
                                    skipPerformance: true,
                                    skipWorkerHoursLimit: true,
                                    closeContainer: closeContainer
                                }
                            },
                                workerDailyHoursLimitMessage
                            );
                            updateShowLoading(false);
                            return;
                        }

                        // tylko limit
                        if (
                            limitMessage &&
                            reportIdState === '0' &&
                            order.is_client_order &&
                            selectedProfile?.type &&
                            (selectedProfile.type === ProfileType.COORDINATOR || selectedProfile.type === ProfileType.TEAM_LEADER)
                        ) {
                            handlePostSaveValidationAlertOpen('reportPage.limitAlert.title', {
                                func: handleSaveReport,
                                params: {
                                    draft,
                                    stay,
                                    skipLimits: true,
                                    skipPerformance: true,
                                    skipWorkerHoursLimit: false,
                                    closeContainer: closeContainer
                                }
                            });
                            updateShowLoading(false);
                            return;
                        }

                        if (!toast && (workerDailyHoursLimitMessage || limitMessage)) {
                            setToast(
                                t(
                                    workerDailyHoursLimitMessage
                                        ? "reportPage.validation.checkLimit"
                                        : "reportPage.validation.limit"
                                )
                            );
                        }

                    } catch (e) {
                        console.error(e);
                    }

                    try {
                        let message = error.response.data.errors.children.ep2ScannedSpecificationId.errors[0];
                        if (!toast && message) {
                            updateOutdatedSpecification(true);
                            setToast(t("reportPage.validation.not_newest_specification"));
                            isErrorMessage = true;
                        }
                    } catch (e) {
                    }

                    try {
                        let message = error.response.data.errors.children.rows.errors[0];
                        if (!toast && message) {
                            setToast(t("reportPage.validation.report.componentNumbersNotUnique") + ' ' +  message.split('=')[1]);
                            isErrorMessage = true;
                        }
                    } catch (e) {
                    }

                    if (toast !== '' && !isErrorMessage) {
                        setToast(t("reportPage.validation.commonError"));
                    }
                } else if (error.response.status === 403) {
                    try {
                        let message = error.response.data?.message;
                        if (message === 'ORDER_BLOCKED_BY_STATUS') {
                            setToast(t('reportsTab.orders.scanSpecificationPage.error.order_blocked_by_status'));
                        } else {
                            setToast(t("reportPage.validation.reportLocked"));
                        }
                    } catch (e) {
                    }
                } else {
                    setToast(t("common.serverErrorMsg"));
                }

                setShowToast(true);
                handleValidationAlertCancel();
            } finally {
                updateShowLoading(false);
                setSaveDisabled(false);
            }

            handleValidationAlertCancel();
        }
    };

    const handlePreSaveValidationAlertConfirm = () => {
        setShowPreSaveValidationAlert(false);
        setTimeout(() => {
            setValidationStep(prevState => prevState + 1);
        }, 300);
    };

    const handlePostSaveValidationAlertConfirm = async () => {
        if (postSaveAction) {
            const action = postSaveAction;
            setPostSaveAction(null);
            await action.func(action.params);
        }
    };

    const handleValidationAlertCancel = () => {
        setShowPreSaveValidationAlert(false);
        setShowPostValidationAlert(false);

        setPreSaveAction(null);
        setPostSaveAction(null);

        setValidationStep(1);
    };

    const handlePreSaveValidationAlertOpen = (alertTitle: string) => {
        setShowPreSaveValidationAlert(true);
        setValidationAlertTitle(alertTitle);
    }

    const handlePostSaveValidationAlertOpen = (alertTitle: string, saveActionCallback: SaveAction, alertMessage?: string) => {
        const formattedMessage = alertMessage?.replace(/<br\s*\/?>/gi, '\n') || null;
        setShowPostValidationAlert(true);
        setValidationAlertTitle(alertTitle);
        setPostSaveAction(saveActionCallback);
        setValidationAlertMessage(formattedMessage || null);
    }

    const validateServiceDateForWorker = async (date: string) => {
        if (selectedProfile) {
            return true;
        }

        const workerFormCheckActiveContract = await Preferences.get({'key': 'worker_form_check_active_contract'});

        if (workerFormCheckActiveContract.value == '0') {
            return true
        }

        let nowDate = moment();
        let valueDate = moment(date);
        let diff = nowDate.diff(valueDate, 'days');
        if (diff == 0 && order?.allow_add_report_forward) {
            return true;
        }
        if (diff == 1){
            return true;
        }

        if (!workerActiveContract) {
            return false;
        }

        const start = moment(workerActiveContract.start_at);
        const end = moment(workerActiveContract.end_at);

        return moment(date).isBetween(start, end, undefined, '[]');
    }

    const syncOfflineData = async(id: string, orderId: string) => {
        let offlineDataStatus = await getOfflineDataStatus();
        if (!offlineDataStatus.valid) {
            let placeOfServiceData = await getReportsData(id, orderId);
            offlineStorageSet('offline_data_' + id, placeOfServiceData.data);
            await Preferences.set({
                'key': 'last_offline_data_update',
                'value': moment().toDate().toString()
            });
        }
    }

    const addNextOrder = () => {
        setAddOrderConfiguration({
            title: 'reportsTab.orders.addNextOrder.title',
            subtitle: 'reportsTab.orders.addNextOrder.subtitle',
            manualButtonText: 'reportsTab.orders.addNextOrder.manual',
            manualFindButtonText: 'reportsTab.orders.addNextOrder.manual_number',
            errorText: 'reportsTab.orders.addNextOrder.error',
            handleManualButton: () => {
                history.push(Links.addNextOrderManual);
            },
            handleManualFindButton: () => {
                history.push(Links.addNextOrderManualFind);
            },
            handleScan: async (val: any, isOrder: boolean, byNumber: boolean) => {
                if (isOrder) {
                    let orderData:Order|string = await findOrderById(val)
                        .then(response => {
                            if (response.status === 200) {
                                return response.data as Order
                            } else {
                                return 'COMMON';
                            }
                        }).catch(reason => {
                            try {
                                let message = reason.response.data?.message;
                                return message !== undefined ? message : 'COMMON';
                            } catch (e) {
                                return 'COMMON';
                            }
                        });

                    if (typeof orderData == 'string') {
                        return getOrderFindErrorReadable(orderData);
                    }

                    return handleAddNextOrderValidation(orderData);
                } else {
                    let orderData:Order|string = await checkSpecification(val)
                        .then(response => {
                            if (response.status === 200) {
                                return response.data as Order
                            } else {
                                return 'COMMON';
                            }
                        }).catch(reason => {
                            try {
                                let message = reason.response.data?.message;
                                return message !== undefined ? message : 'COMMON';
                            } catch (e) {
                                return 'COMMON';
                            }
                        });

                    if (typeof orderData == 'string') {
                        return getOrderFindErrorReadable(orderData);
                    }

                    return handleAddNextOrderValidation(orderData, byNumber);
                }
            },
            handleManualScan: async (val: any) => {
                let orderData:Order|string = await findOrderByNumber(val)
                    .then(response => {
                        return response.data as Order;
                    })
                    .catch(reason => {
                        return reason.response.data.message as string;
                    });

                if (typeof orderData == 'string') {
                    return getOrderFindErrorReadable(orderData);
                }

                return handleAddNextOrderValidation(orderData);
            }
        });

        history.push(Links.addNextOrder);
    }

    const handleAddNextOrderValidation = (orderData: Order, byNumber: boolean = false) => {
        if (orderData && order) {
            if (orderData.id == order.id) {
                return getOrderFindErrorReadable('MULTIPLE_ORDERS_SAME_ORDER')
            } else if (orderData.sub_type !== order.sub_type) {
                return getOrderFindErrorReadable('MULTIPLE_ORDERS_NOT_MATCH_TYPES')
            } else if (orderData.place_of_service.id !== order.place_of_service.id) {
                return getOrderFindErrorReadable('MULTIPLE_ORDERS_NOT_MATCH_POS')
            } else if (!orderData.enable_multiple_order_reports) {
                return getOrderFindErrorReadable('MULTIPLE_ORDERS_MULTIPLE_DISABLED')
            } else if (!orderData.enable_single_components) {
                return getOrderFindErrorReadable('MULTIPLE_ORDERS_SINGLE_COMPONENTS_DISABLED')
            } else {
                if (report) {
                    let tmpAdditionalOrders = report.additionalOrders;
                    let exists = tmpAdditionalOrders.map((v) => v.id).indexOf(orderData.id);
                    if (exists === undefined || exists === -1) {
                        tmpAdditionalOrders.push(orderData);

                        setReport({
                            ...report,
                            additionalOrders: tmpAdditionalOrders
                        });

                        dispatch(EventType["REPORT.DEFECTS.RELOAD"]);
                    }
                }

                history.goBack()
                if (byNumber) {
                    history.goBack();
                }
            }
        }
    }

    const removeAdditionalOrder = (order: Order) => {
        if (report) {
            let tmpAdditionalOrders = report.additionalOrders;
            let exists = tmpAdditionalOrders.map((v) => v.id).indexOf(order.id);
            if (exists !== undefined && exists !== -1) {
                tmpAdditionalOrders.splice(exists, 1);

                setReport({
                    ...report,
                    additionalOrders: tmpAdditionalOrders
                });

                dispatch(EventType["REPORT.DEFECTS.RELOAD"]);
            }
        }
    }

    useEffect(() => {
        checkLocation();
    }, []);

    const checkLocation = async () => {
        let localizationAvailable = await Preferences.get({
            'key': 'localization_available'
        });
        setLatestLocation(undefined);

        const networkStatus = await getCurrentNetworkStatus();
        if (networkStatus && localizationAvailable.value == '1') {
            let latest = await getLatestLocation().then(response => {
                return response.data as Location;
            }).catch(reason => {
                return null;
            });

            if (latest) {
                setLatestLocation(latest);
            }
        }
    }

    return (
        <ReportPageContext.Provider value={contextReportPage}>
            <IonPage className="report">
                <StyledIonContent>
                    <IonHeader ref={header} className="ion-no-border">
                        <StyledIonToolbar>
                            <IonButtons slot="start">
                                <StyledHeaderButton onClick={() => handleBack()}>
                                    <StyledHeaderButtonImage src={ArrowLeftImage}></StyledHeaderButtonImage>
                                </StyledHeaderButton>
                            </IonButtons>
                            <StyledIonTitle className="wrap-text">
                                <div className="wrap-text">
                                    {!reportPreviewBoolean ? t('reportPage.title') : t('reportPage.preview')}
                                </div>
                            </StyledIonTitle>
                            {!reportPreviewBoolean &&
                                <IonButtons slot="end">
                                    <StyledHeaderButton onClick={() => handleSave()}>
                                        <StyledHeaderButtonImage src={CheckImage}></StyledHeaderButtonImage>
                                    </StyledHeaderButton>
                                </IonButtons>
                            }
                        </StyledIonToolbar>
                        {
                            isInternalCostReport &&
                            <StyledBanner color="#000000" backgroundColor="#ffc409">{t("reportPage.internalReport")}</StyledBanner>
                        }
                    </IonHeader>
                    <StaticPane topEdge={topEdge} marginTop={40} hideGrabber={true}>
                        <StyledContent>
                            <div className="content full-height" ref={content}>
                                <StyledReportFormContainer>
                                <IonGrid className="title">
                                    {outdatedSpecification &&
                                        <IonRow>
                                            <IonCol className="label">
                                                <IonText color="danger">
                                                    <h6>{t("reportPage.validation.not_newest_specification")}</h6>
                                                </IonText>
                                            </IonCol>
                                        </IonRow>
                                    }

                                    <IonRow>
                                        <IonCol size="6" className="label">
                                            {t('reportPage.orderId')}
                                        </IonCol>
                                        <IonCol size="6" className="label">
                                            {t('reportPage.orderDate')}
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size="6" className="label">
                                            <StyledInput disabled={true} value={order?.formatted_number}/>
                                        </IonCol>
                                        <IonCol size="6" className="date-field">
                                            <DateInput
                                                presentation="date"
                                                format="DD.MM.YYYY"
                                                onChange={async value => {
                                                    if (validateServiceDateForWorker(value)) {
                                                        setShowToast(false);
                                                        if (report) {
                                                            report.serviceDate = value;
                                                            setReport({
                                                                ...report,
                                                                serviceDate: report.serviceDate
                                                            })

                                                            await clearWorkersPricingRates();
                                                        }

                                                        await validateSickLeave(moment(value).format('YYYY-MM-DD'));
                                                        await validateOfflineWorkerAvailability();
                                                    } else {
                                                        setToast(t("reportPage.validation.noActiveContract"));
                                                        setShowToast(true);
                                                    }
                                                }}
                                                disabled={reportPreviewBoolean || (report && report.someBasketWorker && selectedProfile) ? true : false}
                                                min={order && report ? minReportDate(order, report, selectedProfile) : ''}
                                                max={
                                                    order?.allow_add_report_forward
                                                        ? moment().add(1, 'day').format('YYYY-MM-DD')
                                                        : moment().format('YYYY-MM-DD')
                                                }
                                                cancelText={t("common.dateCancel")}
                                                doneText={t("common.dateDone")}
                                                placeholder={t("common.select")}
                                                className={formSubmitted && report && !report.serviceDate ? 'hasErrors' : ''}
                                                value={(report && report.serviceDate) ? report.serviceDate : moment().format('YYYY-MM-DD')}
                                            />
                                        </IonCol>
                                    </IonRow>
                                    {order && order.logistic_container &&
                                        <>
                                            <IonRow>
                                                <IonCol size="12" className="label">
                                                    {t('reportPage.logisticContainerAdditionalNumber')}
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol size="6" className="label">
                                                    <StyledInput disabled={reportPreviewBoolean}
                                                                 onKeyPress={event => {
                                                                     if (event.key == 'Enter' && !reportPreviewBoolean) {
                                                                         const input = event.target as HTMLInputElement;
                                                                         input.blur();
                                                                     }
                                                                 }}
                                                                 className="full-width"
                                                                 onChange={value => {
                                                                     if (report) {
                                                                         report.logisticContainerAdditionalNumber = value.target.value;

                                                                         setReport({
                                                                             ...report,
                                                                             logisticContainerAdditionalNumber: report.logisticContainerAdditionalNumber
                                                                         })
                                                                     }
                                                                 }}
                                                                 value={report?.logisticContainerAdditionalNumber}
                                                                 placeholder={t('reportPage.reportForm.enter')}/>
                                                </IonCol>
                                                <ScanButton>
                                                    <IonCol size="6" className="scanContainerAdditionalNumber">
                                                        <div
                                                            onClick={() => scanContainerAdditionalNumber('logisticContainerAdditionalNumber')}>
                                                            <span>{t("reportPage.logisticContainerAdditionalNumberScan")}</span>
                                                            <img src={QrImage}/>
                                                        </div>
                                                    </IonCol>
                                                </ScanButton>
                                            </IonRow>
                                            {
                                                formSubmitted && ((report?.logisticContainer?.additional_number && !report?.logisticContainerAdditionalNumber) ||
                                                (logisticContainer?.additional_number && !report?.logisticContainerAdditionalNumber)) &&
                                                <p className="errorMessage">{t('reportPage.reportForm.logisticContainerAdditionalNumberRequired')}</p>
                                            }
                                        </>
                                    }

                                    {isInternalCostReport &&
                                        <>
                                            <IonRow>
                                                <IonCol size="6" className="label required">
                                                    {t('reportPage.internalCostType.title')}
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol size="6" className="select" onClick={() => {
                                                    if (!reportPreviewBoolean) {
                                                        updateShowInternalCostsModal(true)
                                                    }
                                                }}>
                                                    <StyledInput readOnly={true}
                                                                 className={formSubmitted && !report?.internalCostType?.name ? 'hasErrors' : ''}
                                                                 value={report?.internalCostType?.name ? t(report.internalCostType.name) as string : ""} placeholder={t("common.select")} />

                                                    <img className="down" src={ArrowDownImage}/>
                                                </IonCol>
                                            </IonRow>
                                        </>
                                    }

                                    {report?.additionalOrders && report?.additionalOrders.map((value, k) =>
                                       <div key={'additional_order_' + k}>
                                           <IonRow>
                                               <IonCol size="6" className="label">
                                                   {t('reportPage.orderId')}
                                               </IonCol>
                                               <IonCol size="1"></IonCol>
                                           </IonRow>
                                           <IonRow>
                                                <IonCol size="6" className="label">
                                                    <StyledInput disabled={true} value={value.formatted_number}/>
                                                </IonCol>
                                               <IonCol size="1" className="center">
                                                   {reportPreview != '1' && <StyledCircleButton className="white" onClick={() => removeAdditionalOrder(value)}><img src={TrashRedImage} /></StyledCircleButton>}
                                               </IonCol>
                                           </IonRow>
                                       </div>
                                    )}

                                    {!selectedProfile && reportPreview != '1' && order && (order.sub_type === 'OPTIMIZATION' || order.sub_type === 'CONTROL') && order.enable_single_components && order.enable_multiple_order_reports && <IonRow>
                                        <IonCol size="12">
                                            <StyledSocialButton className="inverted" onClick={() => addNextOrder()}>
                                                <img src={AddImage}/>
                                                {t('reportsTab.orders.addNextOrder.addButton')}
                                            </StyledSocialButton>
                                        </IonCol>
                                    </IonRow>}

                                    {order && (order.factory_number || order.complaint_number) &&
                                        <>
                                            <IonRow>
                                                {order.factory_number && <IonCol size="6" className="label">
                                                    {t('reportPage.orderFactoryNumber')}
                                                </IonCol>}
                                                {order.complaint_number && <IonCol size="6" className="label">
                                                    {t('reportPage.orderComplaintNumber')}
                                                </IonCol>}
                                            </IonRow>

                                            <IonRow>
                                                {order.factory_number && <IonCol size="6" className="label">
                                                    <StyledInput disabled={true} value={order.factory_number}/>
                                                </IonCol>}
                                                {order.complaint_number && <IonCol size="6" className="label">
                                                    <StyledInput disabled={true} value={order.complaint_number}/>
                                                </IonCol>}
                                            </IonRow>
                                        </>
                                    }
                                </IonGrid>
                                </StyledReportFormContainer>
                                {

                                    order && report && report.rows.map((row, key) =>
                                        <ReportRowForm
                                            isInternalCostReport={isInternalCostReport}
                                            report={report}
                                            order={order}
                                            profile={selectedProfile}
                                            reportPreview={reportPreviewBoolean}
                                            maxInContainer={maxInContainer}
                                            orderId={order.id}
                                            reportId={reportIdState}
                                            specificationId={specificationId}
                                            orderType={order.sub_type}
                                            maxComponents={order.max_components}
                                            isComponentNumbers={order.is_component_numbers}
                                            logisticContainerComponent={logisticContainer?.component_number}
                                            hideOtherPersons={order.hide_other_persons}
                                            row={row}
                                            onChange={(row) => handleRowChange(row, key)}
                                            onRemove={(row) => handleRowRemove(key)}
                                            onSubmit={() => {
                                                handleSave()
                                            }}
                                            onAutoSave={(rowRef: RefObject<HTMLDivElement>) => {
                                                if (order?.is_extended_reporting) {
                                                    return handleAutoSaveReport(rowRef, key)
                                                        .then((response) => {
                                                            return response
                                                        })
                                                }
                                                return true;
                                            }}
                                            onReportReload={(reportId) => {
                                                return loadReport(true, reportId, true, key, true);
                                            }}
                                            key={'rows_' + key + row.key}/>
                                    )
                                }
                                {
                                    formSubmitted && report && report.rows.length === 0 &&
                                    <p className="errorMessage">{t('reportPage.reportForm.rowsRequired')}</p>
                                }

                                {reportPreview != '1' && (!order || !order.logistic_container) &&
                                    <StyledSocialButton className="bottom-margin black-text" onClick={async () => {
                                        await addRow();

                                        content.current?.scrollTo({
                                            behavior: 'smooth',
                                            top: content.current?.scrollHeight
                                        });
                                    }}>
                                        <img className="button-image" src={AddImage}/>
                                        {!order?.is_extended_reporting ? ((order?.sub_type === 'OPTIMIZATION' || order?.sub_type === 'CONTROL') ? t("reportPage.addButton") : t("reportPage.addButtonOther")) : t("reportPage.addButtonNestedReporting")}
                                    </StyledSocialButton>
                                }
                            </div>
                        </StyledContent>
                    </StaticPane>
                </StyledIonContent>
            </IonPage>
            <IonAlert
                isOpen={alertMessage !== null}
                onDidDismiss={() => setAlertMessage(null)}
                header={t('important_info.header')}
                message={alertMessage || ''}
                buttons={[t('important_info.ok')]}
            />
            <IonAlert
                isOpen={showPreSaveValidationAlert}
                backdropDismiss={false}
                header={t(validationAlertTitle)}
                buttons={[
                    {
                        text: t('common.alertCancel'),
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => handleValidationAlertCancel(),
                    },
                    {
                        text: t('common.alertConfirm'),
                        handler: () => handlePreSaveValidationAlertConfirm(),
                    }
                ]}
            />
            <IonAlert
                isOpen={showPostValidationAlert}
                backdropDismiss={false}
                header={t(validationAlertTitle)}
                message={validationAlertMessage ?? undefined}
                cssClass="alert-pre-line"
                buttons={[
                    {
                        text: t('common.alertCancel'),
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => handleValidationAlertCancel(),
                    },
                    {
                        text: t('common.alertConfirm'),
                        handler: () => handlePostSaveValidationAlertConfirm(),
                    }
                ]}
            />
            {
                selectedProfile
                ?
                    <IonAlert
                        isOpen={showSaveAlert}
                        onDidDismiss={() => setShowSaveAlert(false)}
                        header={t('reportPage.saveAlert.profileTitle')}
                        buttons={profileSaveButtons()}
                    />
                :
                    <IonAlert
                        isOpen={showSaveAlert}
                        onDidDismiss={() => setShowSaveAlert(false)}
                        header={t('reportPage.saveAlert.title')}
                        buttons={workerSaveButtons()}
                    />
            }
            {
                order &&
                <SaveConfirmationModal
                    isOpen={showSaveConfirmationModal}
                    logisticContainer={logisticContainer}
                    onConfirm={async () => {
                        setOmitPageLeavingGuard(false);
                        setShowSaveConfirmationModal(false);
                    }}
                    order={order}
                    onCancel={() => {
                        setOmitPageLeavingGuard(true);

                        setTimeout(() => {
                            setShowSaveConfirmationModal(false);
                            history.goBack();
                        }, 200);
                    }}/>
            }
            <SaveConfirmationHoursAlertModal
                isOpen={showSaveConfirmationHoursAlertModal}
                logisticContainer={logisticContainer}
                onConfirm={async (comment: string) => {
                    setShowSaveConfirmationHoursAlertModal(false)
                    if (report) {
                        report.hoursAlertComment = comment;

                        setReport({
                            ...report,
                            logisticContainerAdditionalNumber: report.logisticContainerAdditionalNumber
                        })
                    }
                    if (autoSaveActionRowRef && autoSaveActionRowKey !== null) {
                        const networkStatus = await getCurrentNetworkStatus();

                        let id = await handleAutoSaveReport(autoSaveActionRowRef, autoSaveActionRowKey)
                            .then((response) => {
                                return response
                            })

                        if (networkStatus && id !== false) {
                            // add new component inside reload
                            await loadReport(true, parseInt(id), true, autoSaveActionRowKey, true)
                        }

                        if (id !== false || !networkStatus) {
                            const componentElement = autoSaveActionRowRef.current?.querySelector(
                                `.row-component`
                            )

                            if (componentElement) {
                                componentElement.scrollIntoView({behavior: 'smooth'})
                            }
                        }

                        setAutoSaveRowRef(null);
                        setAutoSaveRowKey(null);
                    } else {
                        if (actionsParams) {
                            let draft = actionsParams.draft;
                            let stay = actionsParams.stay;
                            setPreSaveAction({
                                func: handleSaveReport,
                                params: {draft: draft, stay: stay, skipLimits: false, skipPerformance: false, skipWorkerHoursLimit: false, closeContainer: closeContainer}
                            });
                        }
                    }
                }}
                onCancel={() => {
                    setShowSaveConfirmationHoursAlertModal(false)
                }}/>
            <IonToast
                isOpen={showToast}
                onDidDismiss={() => {
                    setShowToast(false);
                    setToast('');
                }}
                message={toast}
                duration={6000}
                position="top"
                color="danger"
            />
            <IonAlert
                isOpen={showPermissionAlert}
                onDidDismiss={() => setShowPermissionAlert(false)}
                header={t('common.permissions.alert')}
                buttons={[
                    {
                        text: t('common.alertCancel'),
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            setShowPermissionAlert(false);
                        },
                    },
                    {
                        text: t('common.permissions.goToAppSettings'),
                        handler: async () => {
                            setShowPermissionAlert(false);
                            BarcodeScanner.openAppSettings();
                        }
                    }
                ]}
            />
            <IonAlert
                isOpen={showLeaveLocationAlert}
                onDidDismiss={() => {
                    setShowLeaveLocationAlert(false)
                }}
                header={t('reportPage.leaveLocationAlertHeader')}
                buttons={[
                    {
                        text: t('reportPage.leaveLocationAlertStayInLocation'),
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            setShowLeaveLocationAlert(false);
                            history.replace(Links.main + Links.reports);
                        }
                    },
                    {
                        text: t('reportPage.leaveLocationAlertLeaveLocation'),
                        handler: async () => {
                            updateShowLoading(true);
                            setShowLeaveLocationAlert(false);

                            let hasPermissions = await Geolocation.checkPermissions()
                                .then((location) => {
                                    return location.location;
                                })
                                .catch(reason => {
                                    return 'error';
                                });

                            if (hasPermissions === 'denied' || hasPermissions === 'error') {
                                setShowPermissionAlert(true);
                            } else {
                                await leave()
                                    .then((response) => {
                                        updateShowLoading(false);
                                        history.replace(Links.main + Links.reports);
                                    })
                                    .catch(reason => {
                                        setToast({
                                            message: t('locationLeaveModal.error'),
                                            type: 'danger'
                                        });
                                    })
                            }

                            updateShowLoading(false);
                        }
                    }
                ]}
            />

            {isInternalCostReport && orderInternalCosts && <ListModal
                       list={orderInternalCosts}
                       isOpen={showInternalCostsModal}
                       onClose={() => updateShowInternalCostsModal(false)}
                       selected={report?.internalCostType?.id}
                       translate={true}
                       onSubmit={(selected) => {
                           if (report) {
                               setReport({
                                   ...report,
                                   internalCostType: selected
                               })
                           }
                           updateShowInternalCostsModal(false);
                       }} search={true}/> }

            <QrScannerModal logisticContainer = {true} isOpen={showScanModal} onClose={() => {
                setShowScanModal(false);
                setScanField('');
            }} onSubmit={(value) => {
                handleScan(value);
            }}/>
            <PageLeavingGuard
                navigate={path => {
                    history.goBack()
                }}
                when={!reportPreviewBoolean}
                shouldBlockNavigation={location => {
                    if (order) {
                        if (formSaved) {
                            return false;
                        }

                        if (omitPageLeavingGuard) {
                            return false;
                        }

                        if (location.pathname === Links.qrCodeWorker ||
                            location.pathname === (Links.choosePerson + '/' + order.id + '/' + moment(report && report.serviceDate ? report.serviceDate : null).format('DD-MM-YYYY')) ||
                            location.pathname === (Links.choosePersonExtended + '/' + order.id + '/' + specificationId + '/' + moment(report && report.serviceDate ? report.serviceDate : null).format('DD-MM-YYYY') + '/' + reportIdState) ||
                            location.pathname.includes(Links.report + '/' + order.id + '/' + specificationId) || // to prevent alter on change reportIdState
                            location.pathname === Links.addNextOrder ||
                            location.pathname === Links.addNextOrderManual ||
                            location.pathname === Links.addNextOrderManualFind
                        ) {
                            return false;
                        }
                        return true;
                    }
                    return false;
                }}/>
            <IonLoading isOpen={showLoading}/>
        </ReportPageContext.Provider>
    );
};

export default ReportPage;
